import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE } from '../constants';
import { invokeApi, invokeApiDataDome } from './common';
import { initVerificationAction } from './verification';

/*
	Actions
*/

function initPasswordAction(data) {
	return {
		type: 'INIT_PASSWORD_CHANGE',
		data: data
	}
}

function changePasswordAction(data) {
	return {
		type: 'CHANGE_PASSWORD',
		data: data
	}
}

/*
	Async functions
*/
export function initPassword() {
	return invokeApi(
		'/api/account/password/init',
		{
			credentials: 'same-origin'
		},
		(dispatch, data) => handleInitPassword(dispatch, data)
	)
}

export function changePassword(password, newPassword) {
	return invokeApiDataDome(
		'/api/account/password/change',
		{
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				Accept: 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				password: password,
				new_password: newPassword,
			})
		},
		handleChangePassword
	)
}

/*
 Helper functions
 */
function handleInitPassword(dispatch, data) {
	switch (data.next_action.action_type) {
		case ACTION_TYPE.TWO_STEP_VERIFICATION:
            dispatch(initVerificationAction(data));
            browserHistory.push('/security/password/2-step-verification');
			break;
		case ACTION_TYPE.CHANGE_PASSWORD:
            dispatch(initPasswordAction(data));
            browserHistory.push('/security/password/change');
            break;
		case ACTION_TYPE.CONTACT_CUSTOMER_SERVICE:
			browserHistory.push('/security/password/contact-customer-service');
			break;
		case ACTION_TYPE.NEED_BIND_MOBILE:
			browserHistory.push('/security/password/need-bind-mobile');
			break;
		default:
			break;
	}
}

function handleChangePassword(dispatch, data) {
	if (data.status === 0 && data.next_action.action_type === ACTION_TYPE.DONE) {
		browserHistory.push('/security/password/done');
	}
	dispatch(changePasswordAction(data));
}



// WEBPACK FOOTER //
// ./app/actions/password.js